import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ProductCard from '../components/ProductCard';
import { Checkbox } from '../components/ui/checkbox';
import { useData } from '../context/DataContext';
import { api } from '../lib/api';
import { ChevronRight, SlidersHorizontal } from 'lucide-react';

const MainCategoryPage = () => {
  const { slug } = useParams();
  const { tree, loading } = useData();
  const [products, setProducts] = useState([]);
  const [sortBy, setSortBy] = useState('relevance');

  const main = tree.find((m) => m.slug === slug || m.id === slug);

  useEffect(() => {
    if (!main) return;
    api.getProducts({ main_category_id: main.id, sort: sortBy, limit: 24 })
      .then((d) => setProducts(d.items || [])).catch(() => {});
  }, [main, sortBy]);

  if (loading) {
    return <div><Header /><div className="max-w-7xl mx-auto px-4 py-20 text-center text-gray-500">Loading...</div><Footer /></div>;
  }
  if (!main) {
    return (
      <div>
        <Header />
        <div className="max-w-7xl mx-auto px-4 py-20 text-center">
          <h1 className="text-2xl font-bold">Department not found</h1>
          <Link to="/" className="text-[#2c54b2] hover:underline mt-4 inline-block">Go back home</Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />

      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-1 text-xs text-gray-600">
          <Link to="/" className="hover:text-[#2c54b2]">Home</Link>
          <ChevronRight className="w-3 h-3" />
          <span className="text-gray-900 font-medium">{main.name}</span>
        </div>
      </div>

      <section className="bg-gradient-to-r from-[#2c54b2] to-[#1e3a8a] text-white">
        <div className="max-w-7xl mx-auto px-4 py-8">
          <h1 className="text-3xl font-bold">{main.name}</h1>
          <p className="text-blue-100 mt-1">{(main.categories || []).length} categories • Verified Vendors across Telangana</p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 py-6">
        {/* Categories under this main */}
        <h2 className="text-xl font-bold text-gray-900 mb-4">Browse Categories</h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mb-10">
          {(main.categories || []).map((cat) => (
            <Link key={cat.id} to={`/category/${cat.slug}`}
              className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-md hover:border-[#ee5e23] transition-all flex gap-3 items-center p-3">
              <img src={cat.image} alt={cat.name} className="w-16 h-16 rounded object-cover bg-gray-50" />
              <div className="min-w-0">
                <div className="font-semibold text-sm text-gray-900 line-clamp-2">{cat.name}</div>
                <div className="text-xs text-gray-500 mt-0.5">{(cat.sub_categories || []).length} sub-categories</div>
              </div>
            </Link>
          ))}
        </div>

        {/* Top products in this main */}
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-xl font-bold text-gray-900">Top Products in {main.name}</h2>
          <select value={sortBy} onChange={(e) => setSortBy(e.target.value)} className="text-sm border border-gray-300 rounded px-2 py-1 focus:outline-none focus:border-[#ee5e23]">
            <option value="relevance">Relevance</option>
            <option value="price-low">Price: Low to High</option>
            <option value="price-high">Price: High to Low</option>
          </select>
        </div>
        {products.length === 0 ? (
          <div className="bg-white border border-gray-200 rounded-md py-12 text-center text-gray-600">No products yet in this department.</div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
            {products.map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default MainCategoryPage;
